export const SET_STATE = 'deal/SET_STATE';
export const SET_FETCHING = 'deal/SET_FETCHING';
export const SET_BOOKING = 'deal/SET_BOOKING';
export const SET_DEAL = 'deal/SET_DEAL';
export const SET_FILTERED_DEPARTURES = 'deal/SET_FILTERED_DEPARTURES';
export const SET_SELECTED_DEPARTURE_ID = 'deal/SET_SELECTED_DEPARTURE_ID';
export const RESET_STATE = 'deal/RESET_STATE';
